module.exports = __webpack_public_path__ + "static/media/stok.ec44dc25.png";